import { render, staticRenderFns } from "./AdminFaults.vue?vue&type=template&id=309eaa8f&scoped=true"
import script from "./AdminFaults.vue?vue&type=script&lang=js"
export * from "./AdminFaults.vue?vue&type=script&lang=js"
import style0 from "./AdminFaults.vue?vue&type=style&index=0&id=309eaa8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309eaa8f",
  null
  
)

export default component.exports